// Ripple from the centre of the image
vec3 displace(vec3 pos, vec2 uv, inout float elevation)
{
    float t = uTime * uSpeed;
    vec2 p = (uv - 0.5) * 2.0;  // uv-based so it works on any shape
    float d = length(p);
    elevation = sin(d * uFrequency * 2.0 - t * 3.0) / (1.0 + d * 2.0);
    pos += normal * elevation * uStrength;
    return pos;
}
